export type PositionedPlaylistItem = {
    isStatic: boolean;
    position: number;
};

export type PlaylistItemAsset = {
    asset: {
        id: number;
        provider: string;
        duration: number;
        category: number;
    };
} & PositionedPlaylistItem;

export type PlaylistItemPlaylist = {
    playlist: {
        id: string;
        provider: string;
    };
} & PositionedPlaylistItem;

export type PlaylistItem = PlaylistItemAsset | PlaylistItemPlaylist;

export type PlaylistLabel = {
    id: string;
    name: string;
    type: string;
};

type PlaylistCommon = {
    id: string;
    name: string;
    provider: string;
    header: string | null;
    query: string | null;
    searchQuery: string | null;
    limit: number;
    locked: boolean;
    labels: PlaylistLabel[];
    metadata: string | null;
    items: PlaylistItem[];
    partnerName: string | null;
    partnerPlaylistAlias: string | null;
    themeId?: string;
};

export type PlaylistOfAssets = {
    assets: PlaylistItemAsset[];
    playlists?: never;
} & PlaylistCommon;

export type PlaylistOfPlaylists = {
    assets?: never;
    playlists: PlaylistItemPlaylist[];
} & PlaylistCommon;

export type Playlist = PlaylistOfAssets | PlaylistOfPlaylists;

export const THEME_IMAGE_TYPES = ['iconLight', 'iconDark', 'backgroundImageLight', 'backgroundImageDark'] as const;
export type ThemeImageType = (typeof THEME_IMAGE_TYPES)[number];

export interface FormValues {
    name: string;
    header: string | null;
    query: string | null;
    limit: number;
    searchQuery: string | null;
    type: string;
    labels: string[];
    metadata: { key: string; value: string }[];
    items: PlaylistItem[];
    isPodcastPlaylist?: boolean;
    partnerName: string | null;
    partnerPlaylistAlias: string | null;
    useLimitPerCategory: boolean;
}
